import { Box, Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { ApplicationSubmitFormValues, RevokeCheckboxField } from '../types.ts';
import { REVOKE_CHECKBOX_FIELDS } from '../constants/revokeCheckboxFields.ts';

export const ApplicationWhyRevokeForm = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<ApplicationSubmitFormValues>();

  const values = watch();
  const isOtherReasonSelected = !!values?.otherReason;

  const createSingleOptionHandler = (fieldName: RevokeCheckboxField) => (isChecked: boolean) => {
    REVOKE_CHECKBOX_FIELDS.forEach((field) => {
      setValue(field, isChecked && fieldName === field, {
        shouldTouch: true,
        shouldValidate: true,
        shouldDirty: true,
      });
    });

    if (!isChecked || fieldName !== 'otherReason') {
      setValue('otherReasonDescription', null, {
        shouldTouch: true,
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <FormCheckbox
            name="disagreeWithProcessingPurpose"
            onChange={createSingleOptionHandler('disagreeWithProcessingPurpose')}
            formControlLabelProps={{ 'data-testid': 'disagreeProcessing' }}
            label="Не погоджуюсь з метою обробки моїх персональних даних"
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCheckbox
            name="disagreeWithPersonalDataScope"
            onChange={createSingleOptionHandler('disagreeWithPersonalDataScope')}
            formControlLabelProps={{ 'data-testid': 'disagreeScope' }}
            label="Не погоджуюсь із обсягом моїх персональних даних, який оброблятиметься Банком"
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCheckbox
            name="otherReason"
            onChange={createSingleOptionHandler('otherReason')}
            formControlLabelProps={{ 'data-testid': 'otherReasonCheckbox' }}
            label="Інша причина"
          />
        </Grid>

        {!!errors.atLeastOneCheckbox && (
          <Grid size={{ xs: 12 }}>
            <Typography
              color="error"
              variant="caption"
              data-testid="atLeastOneCheckbox-error"
              sx={{ ml: 1.5 }}
            >
              {errors.atLeastOneCheckbox?.message as string}
            </Typography>
          </Grid>
        )}

        {isOtherReasonSelected && (
          <Grid size={{ xs: 12 }}>
            <FormInput
              name="otherReasonDescription"
              fullWidth
              multiline
              minRows={4}
              label="Опишіть іншу причину"
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
